import { Component, Mixins, Watch } from 'vue-property-decorator';
import { getComponentProps } from '@/utils/vueUtils';
import { DerSubscribeBlockViewModel, ChoiseType } from './DerSignUpModule.types';
import SecondStep from './SecondStep/SecondStep.vue';
import StoreModuleMixin from '@/mixins/StoreModuleMixin';
import { SET_CHOISE, SUBMIT_FORM } from './DerSignUpModule.store';
import { SecondStepModel } from './SecondStep/SecondStep.types';
import { SegmentElement, SegmentTrackEvents } from '@/plugins/utm/SegmentElement';
import { getFormPayload } from '@/utils/commonUtils';
import RecaptchaMixin from '@/forms/FormElements/Mixins/RecaptchaMixin';
import Cookies from 'js-cookie';

@Component({
  components: {
    SecondStep,
  },
  props: getComponentProps<DerSubscribeBlockViewModel>({
    Destinations: [
      {
        Text: 'Alaska',
        Value: 2,
      },
    ],
    Choises: [
      {
        Text: 'My friends and family',
        Value: '1',
      },
    ],
    PrivacyPolicyLink: '#',
    BottomText: 'I authorize Lindblad Expeditions to email me; however, I am able to unsubscribe at any time. For more details, see our <a "href="#" target="_blank">Privacy Policy</a>.',
  }),
})
export default class DerSignUpModule extends Mixins(StoreModuleMixin, RecaptchaMixin) {
  p!: DerSubscribeBlockViewModel;
  setChoiseRequest: (choise: string) => void = this.getMutation(SET_CHOISE);
  submitForm: (model: SecondStepModel) => void = this.getAction(SUBMIT_FORM);

  clientFormSubmittedPayload: any = {};

  get choise() {
    return this.state.Choise;
  }

  get choises() {
    const ordered =
      this.p.Choises && this.p.Choises.length > 0
        ? [
            this.findChoiseByValue(ChoiseType.FriendsAndFamily),
            this.findChoiseByValue(ChoiseType.Me),
            this.findChoiseByValue(ChoiseType.Both),
          ]
        : [];
    return ordered;
  }

  findChoiseByValue(value: string) {
    return this.p.Choises.find((c) => c.Value == value);
  }

  setChoise(data: any) {
    this.setChoiseRequest(data.Choise);
  }

  created() {
    this.siteKey = '6Lelwv4eAAAAAHavTU2624NBQb8SDFnhmZzpvgZH';
  }

  mounted() {
    SegmentElement.sendEvent('formViewed', {
      ...getFormPayload('DerSignUp', this.$attrs.contentLinkId),
      nonInteraction: 1,
    })
  }

  async submitSecondStep(model: SecondStepModel) {
    model.RecaptchaResponse = await this.getRecaptchaToken()
    this.clientFormSubmittedPayload = getFormPayload('DerSignUp', this.$attrs.contentLinkId);
    SegmentElement.sendEvent('formSubmissionAttempted', this.clientFormSubmittedPayload)

    const serverPayload = {
      ...this.clientFormSubmittedPayload,
      ...(!SegmentElement.getIsLanding() && { previous_page_name: SegmentElement.getPrevPageName() }),
      page_name: SegmentElement.getPageName(),
      locale: SegmentElement.getLocale(),
      email: model.Person.Email,
      first_name: model.Person.FirstName,
      last_name: model.Person.LastName,
      ...(Cookies.get('_fbc') && { fbclid: Cookies.get('_fbc').split('.')[3] }),
      ...(Cookies.get('email_md5') && { email_md5: Cookies.get('email_md5') }),
      ...(Cookies.get('_uetmsclkid') && { mscklid: Cookies.get('_uetmsclkid').split('_uet')[1] }),
      ...(Cookies.get('_gcl_aw') && { gclid: Cookies.get('_gcl_aw').split('.')[2] }),
    };

    this.submitForm({ ...model, AnalyticsPayload: JSON.stringify(serverPayload) });
  }

  @Watch('state.ShowThankYouMessage')
  formSubmitted() {
    this.clientFormSubmittedPayload.transaction_id = this.state.transaction_id;
    SegmentElement.sendEvent(SegmentTrackEvents.formSubmitted, this.clientFormSubmittedPayload);
  }
}
